import Model, { attr, hasMany } from '@ember-data/model';
import { notEmpty } from '@ember/object/computed';
import currency from 'currency.js';
import { pledgeFrequencyLabels } from 'donor-elf-web/lib/pledge-utils';
import CampaignPledgeModel from './campaign-pledge';

let annualAmountMultiplier = {
  Monthly: 12,
  'Bi-Monthly': 6,
  Quarterly: 4,
  'Semi-Annual': 2,
  Annual: 1,
};

export default class PledgeModel extends Model {
  @attr('string') contactId?: string;
  @attr('number') declare frequency: number;
  get frequencyLabel(): string {
    return (pledgeFrequencyLabels as any)[this.frequency];
  }
  // @ts-ignore
  @attr('date-only') declare startDate: Date;
  // @ts-ignore
  @attr('date-only') endDate?: Date;
  @attr('number') amount?: number;
  @attr('string') notes?: string;
  @attr('number') monthlyAmount?: number;

  get annualAmount() {
    // have to multiply monthlyAmount because that takes into account how many months the pledge is spread out
    if (this.frequencyLabel === 'One Time') {
      return Math.min(
        currency(this.monthlyAmount || 0).multiply(12).value,
        this.amount || 0,
      );
    }
    let multiplier = (annualAmountMultiplier as any)[this.frequencyLabel] || 1;
    return currency(this.amount || 0).multiply(multiplier).value;
  }

  // @ts-ignore
  @attr('date-only') declare lastDonationDate?: Date;
  // @ts-ignore
  @attr('date-only') declare nextExpectedDonationDate?: Date;
  @notEmpty('lastDonationDate') declare hasGifts: boolean;
  @attr('boolean') declare isManual?: boolean;
  @attr('boolean') affectsGoal!: boolean;

  @hasMany('campaign-pledge', { async: false, inverse: null })
  campaignPledges?: CampaignPledgeModel[];

  get campaignPledgesArray() {
    return this.campaignPledges?.slice() || [];
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    pledge: PledgeModel;
  }
}
